<div class="container">
    <div class="title">404</div>
    <div class="subtitle">Página no encontrada</div>
</div>